import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminDeleted_itemsBuildings = z.any()
export type TagsGetAdminDeleted_itemsBuildings = z.infer<typeof tagsGetAdminDeleted_itemsBuildings>

export const responseGetAdminDeleted_itemsBuildings = z.object({ "payload": z.array(z.object({ "id": z.string(), "name": z.string(), "address": z.string().optional(), "municipality": z.object({ "name": z.string() }), "deletedAt": z.string().datetime({ offset: true }) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminDeleted_itemsBuildings = z.infer<typeof responseGetAdminDeleted_itemsBuildings>

interface IGetAdminDeleted_itemsBuildings extends BaseMethodType {
  tags: TagsGetAdminDeleted_itemsBuildings,
  response: ResponseGetAdminDeleted_itemsBuildings
}
export const URL = '/admin/deleted-items/buildings'
export const validation = {
  get: {
    tags: tagsGetAdminDeleted_itemsBuildings,
    response: responseGetAdminDeleted_itemsBuildings
  }
}
export interface AdminDeleted_itemsBuildings extends BaseRouteType {
  get: IGetAdminDeleted_itemsBuildings
}